import { render, staticRenderFns } from "./goodsCustomTemplateNewDialog.vue?vue&type=template&id=fe70569e"
import script from "./goodsCustomTemplateNewDialog.vue?vue&type=script&lang=js"
export * from "./goodsCustomTemplateNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports